// @libraries
import * as Yup from 'yup'

const firstName = Yup.string()
  .required('First Name is required!')
  .matches(/^(?!test$)/, {
    message: 'That name is not allowed!',
  })

const lastName = Yup.string()
  .required('Last Name is required!')
  .matches(/^(?!test$)/, {
    message: 'That name is not allowed!',
  })
const primaryEmailAddress = Yup.string()
  //.email('Please enter your email in a valid format.')
  .required('Email is required!')

const password = Yup.string()
  .min(7, 'Must be 7 characters or more')
  .matches(/^(?=.*\d).+$/, 'Password must contain at least one number')
  .required('Password is required!')

const passwordRetype = Yup.string()
  .oneOf([Yup.ref('password')], 'Password does not match')
  .required('Password is required!')

const role = Yup.string().required('Role is required!')

const industry = Yup.string().required('Industry is required!')

const addressType = Yup.string().required('Type of address is required!')

const companyName = Yup.string().when('addressType', {
  is: (type) => type === 'business',
  then: Yup.string().required('Company Name is required'),
})

const countryCode = Yup.string().required('Country is required!')

const address1 = Yup.string().required('Address is required!')

const city = Yup.string().required('City is required!')

const postalCode = Yup.string().required('Zip code is required!')

const state = Yup.string().when(['countryCode'], {
  is: (countryCode) => {
    return countryCode === 'CA' || countryCode === 'US'
  },
  then: Yup.string().required('State is required!'),
  otherwise: Yup.string(),
})
const acceptTerms = Yup.boolean().oneOf([true], 'Must accept before proceeding')

const acceptGDPR1 = Yup.boolean().oneOf([true], 'Must accept before proceeding')

const acceptGDPR2 = Yup.boolean().oneOf([true], 'Must accept before proceeding')

const acceptGDPRCA = Yup.boolean().oneOf(
  [true],
  'Must accept before proceeding',
)

export const validationSchema = Yup.object().shape({
  firstName,
  lastName,
  primaryEmailAddress,
  password,
  passwordRetype,
  role,
  industry,
  addressType,
  companyName,
  countryCode,
  address1,
  city,
  postalCode,
  state,
  acceptTerms,
  acceptGDPR1,
  acceptGDPR2,
  acceptGDPRCA,
})
